import React, {useEffect, useState} from 'react'
import {Navigate, Route, Routes, Outlet} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {Overview} from './components/Overview'
import {Settings} from './components/settings/Settings'
import {AccountHeader} from './AccountHeader'
import axios from 'axios'
import {BASE_URL} from '../../../api'
import {useSelector} from 'react-redux'

// import {gql, useQuery} from '@apollo/client'

const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/crafted/account/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const AccountPage: React.FC = () => {
  // const {loading, error, data}: any = useQuery(GET_ADMIN_QUERY)
  const [data, setData] = useState<any>('')
  const [error, setError] = useState<string>('Something went wrong')

  const admin = useSelector((state: any) => state.auth.admin)

  return (
    <Routes>
      <Route
        element={
          <>
            <AccountHeader data={admin} />
            <Outlet />
          </>
        }
      >
        <Route
          path='overview'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
              <Overview data={admin} />
            </>
          }
        />
        <Route
          path='settings'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
              <Settings data={admin} error={error} />
            </>
          }
        />
        <Route index element={<Navigate to='/crafted/account/overview' />} />
      </Route>
    </Routes>
  )
}

export default AccountPage
